var map = {
	"./alelo.png": 46330,
	"./alterarSenha.png": 24189,
	"./atencao.png": 66692,
	"./avatar.png": 37482,
	"./avatars/avatar-1.png": 42945,
	"./avatars/avatar-2.png": 1866,
	"./avatars/avatar-3.png": 33779,
	"./avatars/avatar-4.png": 36380,
	"./avatars/avatar-5.png": 72293,
	"./avatars/avatar-6.png": 44462,
	"./avatars/avatar-7.png": 43959,
	"./avatars/avatar-8.png": 27600,
	"./avatars/avatar-pj.png": 12992,
	"./bankSlipModal.png": 8202,
	"./banner-informativo-info-pagamento.png": 74496,
	"./banner-ja-baixou-o-app.png": 97454,
	"./banner-zapay.png": 62831,
	"./blocked-car.png": 99940,
	"./botao-google-app.png": 50822,
	"./botao-ios-app.png": 83376,
	"./cancelAccount.png": 934,
	"./cancela.png": 41946,
	"./car.png": 72599,
	"./car2.png": 68005,
	"./close.png": 65417,
	"./confirmation.png": 64746,
	"./contestacao.png": 45989,
	"./copyIcon.png": 50593,
	"./disponivel-na-app-store.png": 89474,
	"./disponivel-na-play-store.png": 20601,
	"./fuel.png": 68749,
	"./hand.png": 3982,
	"./ic-arrow-blue-left.png": 72896,
	"./ic-check.png": 71338,
	"./ic-check@2x.png": 35834,
	"./ic-check@3x.png": 82789,
	"./ic-picker-plus.png": 40513,
	"./ic-search.png": 55124,
	"./iconDownload.png": 55130,
	"./iconPrint.png": 52761,
	"./iconShare.png": 39585,
	"./logoVeloe.png": 77827,
	"./mail-to.png": 96332,
	"./mail-to@2x.png": 68796,
	"./mail-to@3x.png": 40295,
	"./modalBuddies.png": 68132,
	"./modalBuddies@2x.png": 99316,
	"./modalBuddies@3x.png": 49567,
	"./moto.png": 86754,
	"./park.png": 97397,
	"./perfil-1@2x.png": 36159,
	"./perfil-1@3x.png": 37492,
	"./qrbb.png": 85168,
	"./recarga.png": 42162,
	"./semaphore.png": 22500,
	"./semiautomatico/band.png": 20117,
	"./semiautomatico/smartband.png": 62908,
	"./semiautomatico/tag.png": 98782,
	"./toll.png": 20894,
	"./truck-travel.png": 50735,
	"./truck-travel@2x.png": 92833,
	"./truck-travel@3x.png": 72054,
	"./unblocked-car.png": 98467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;